var _effectorFileName = "/builds/gmini/front-ui-kit/src/Button/Button.styled.ts";
import styled, { css } from 'styled-components';
export const LeftIcon = styled.div`
  display: flex;

  & svg {
    width: ${props => props.size === 'small' ? '20px' : '24px'};
    height: ${props => props.size === 'small' ? '20px' : '24px'};
    min-width: ${props => props.size === 'small' ? '20px' : '24px'};
    min-height: ${props => props.size === 'small' ? '20px' : '24px'};
  }
`;
export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: fit-content;
  gap: 3px;
  border: none;
  padding: ${props => props.size === 'small' || props.withIcon ? '6px 8px' : '8px'};
  border-radius: 4px;
  transition: all 0.2s ease-out;
  font-weight: 500;
  font-size: ${props => props.size === 'small' ? '12px' : '14px'};
  line-height: 20px;
  font-family: Roboto, sans-serif;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  ${props => props.fullWidth && css`
      width: 100%;
    `}

  path {
    transition: background-color 0.2s ease-out, color 0.2s ease-out;
  }

  &:disabled {
    pointer-events: none;
    cursor: pointer;
    background: rgba(53, 59, 96, 0.05);
    color: rgba(53, 59, 96, 0.2);

    path {
      fill: rgba(53, 59, 96, 0.2);
    }
  }
`;
export const PrimaryButton = styled(Button)`
  color: #ebebef;
  background: #353b60;
  ${props => !props.disabled && props.active && css`
      background: #353b60;
    `}

  & path {
    fill: #ebebef;
  }

  &:hover {
    background: #00003d;
  }

  &:active {
    background: #353b60;
  }
`;
export const SecondaryButton = styled(Button)`
  background: rgba(53, 59, 96, 0.05);
  color: #353b60;

  ${props => !props.disabled && props.active && css`
      background: rgba(53, 59, 96, 0.2);
    `}

  & path {
    fill: #353b60;
  }

  &:hover {
    background: rgba(53, 59, 96, 0.1);
  }

  &:active {
    background: rgba(53, 59, 96, 0.2);
  }
`;
export const TertiaryButton = styled(Button)`
  background: inherit;
  color: #4c5ecf;
  ${props => !props.disabled && props.active && css`
      background: rgba(53, 59, 96, 0.2);
    `}

  & path {
    fill: #4c5ecf;
  }

  &:hover {
    background: rgba(53, 59, 96, 0.1);
  }

  &:active {
    background: rgba(53, 59, 96, 0.2);
  }

  &:disabled {
    background: inherit;
  }
`;
export const WarningButton = styled(Button)`
  background: rgb(217, 87, 94);
  color: #fff;
  ${props => !props.disabled && props.active && css`
      background: rgb(217, 87, 94);
    `}

  & path {
    fill: #fff;
  }

  &:hover {
    background: rgb(191, 55, 55);
  }

  &:active {
    background: rgb(217, 87, 94);
  }
`;
export const InfoButton = styled(Button)`
  background: #4c5ecf;
  color: #fff;
  ${props => !props.disabled && props.active && css`
      background: #4c5ecf;
    `}

  & path {
    fill: #fff;
  }

  &:hover {
    background: #2235aa;
  }

  &:active {
    background: #4c5ecf;
  }
`;